import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    Funnel,
    ChevronUp,
    ChevronDown,
    LinkIcon,
} from 'lucide-react';
import { useHistory } from 'react-router-dom';

const dummyData = [
    {
        id: 1,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'To Ship',
        itemsCount: 5,
        orderTotal: 'SGD 1,433.27',
        finalTotal: '',
        linkage: 'Not linked (n)',
        listings: [
            {
                id: 'L-S1',
                listingName: 'Samsung Galaxy Z Fold 7\nSnapdragon 8 Elite | Z Fold 6 | Z Fold 5 | 5G | 256GB 512GB 1TB | 1 Year Samsung SG Warranty',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Z Fold 7 12GB 512GB, Blue Shadow',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Samsung Galaxy Z Fold 7',
                mappedStockSku: 'SKU: 12GB 512GB,Blue Shadow',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            },
            {
                id: 'L-S2',
                listingName: 'Mister Mobile Mercury Goospery Phone Case',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Clear',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Stock not found please map it to a stock in Listing',
                mappedStockSku: '',
                mappedStockBadges: [],
                stockInstance: '',
                stockInstanceLocation: '',
                stockInstanceDate: '',
                instanceQty: 1,
                instanceStatus: '',
                rowBg: 'stockout',
            },
            {
                id: 'L-S3',
                listingName: 'Mister Mobile Tempered Glass/Screen Protector',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Screen Protector, Samsung (All Models)',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Mister Mobile Tempered Glass/Screen Protector',
                mappedStockSku: 'SKU: Screen Protector,Samsung (All Models)',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            },
            {
                id: 'L-S4',
                listingName: 'Mister Mobile Mascot Cable Protector',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Clear',
                qty: 1,
                unitPrice: 'SGD 0',
                mappedStock: 'Mister Mobile Mascot Cable Protector',
                mappedStockSku: 'SKU: Clear',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            },
            {
                id: 'L-S5',
                listingName: 'Samsung 25W USB-C Power Adapter Singapore',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Adapter (Black), Original',
                qty: 1,
                unitPrice: 'SGD 16.00',
                mappedStock: 'Samsung 25W USB-C Power Adapter Singapore',
                mappedStockSku: 'SKU: Adapter (Black),Original',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            },
        ]
    },
    // keep remaining orders minimal to fill table (unchanged structure)
    {
        id: 2,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'To Ship',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: '',
        linkage: 'Not linked (n)',
        listings: [
            {
                id: 'L-T1',
                listingName: 'Samsung 25W USB-C Power Adapter Singapore',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Adapter (Black), Original',
                qty: 1,
                unitPrice: 'SGD 16.00',
                mappedStock: 'Samsung 25W USB-C Power Adapter Singapore',
                mappedStockSku: 'SKU: Adapter (Black),Original',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            }
        ]
    },
    {
        id: 3,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Tik Tok SG',
        platformStatus: 'To Ship',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: '',
        linkage: 'Not linked (n)',
        listings: [
            {
                id: 'L-T1',
                listingName: 'Samsung 25W USB-C Power Adapter Singapore',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Adapter (Black), Original',
                qty: 1,
                unitPrice: 'SGD 16.00',
                mappedStock: 'Samsung 25W USB-C Power Adapter Singapore',
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            }
        ]
    },
    {
        id: 4,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'To Ship',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: '',
        linkage: 'Not linked (n)',
        listings: [
            {
                id: 'L-T1',
                listingName: 'Samsung 25W USB-C Power Adapter Singapore',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Adapter (Black), Original',
                qty: 1,
                unitPrice: 'SGD 16.00',
                mappedStock: 'Samsung 25W USB-C Power Adapter Singapore',
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            }
        ]
    },
    {
        id: 5,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Lazada SG',
        platformStatus: 'Shipped',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 6,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'Shipped',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 7,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Tik Tok SG',
        platformStatus: 'Shipped',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 8,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Lazada SG',
        platformStatus: 'Completed',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 9,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Tik Tok SG',
        platformStatus: 'Completed',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 10,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'Completed',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    },
    {
        id: 11,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Tik Tok SG',
        platformStatus: 'Completed',
        itemsCount: 1,
        orderTotal: 'SGD 1,399.00',
        finalTotal: 'SGD 1,200.50',
        linkage: 'All Linked',
        listings: []
    }
];

const PAGE_SIZE = 10; // Display all 10 rows on one page

export default function PlatformOrderLinked() {
    // ===== keep all your original states & refs exactly as before =====
    const [activeTab, setActiveTab] = useState('platform-order');
    const breadcrumbs = ["Order", "Platform Order"];
    const history = useHistory();

    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [suppressHighlight, setSuppressHighlight] = useState(false);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState('entity-info');
    const [selectedRow, setSelectedRow] = useState(null);

    // NEW: minimal accordion state (only this was added)
    const [expandedIds, setExpandedIds] = useState([]);

    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRefs = useRef({});
    const drawerRef = useRef(null);

    const tableRef = useRef();
    const imeiDropdownRef = useRef(null);

    const drawerContainerRef = useRef(null);
    const filterDrawerRef = useRef(null);

    // ========= keep your existing filtered logic (name 'filtered') =========
    const filtered = useMemo(() => {
        const term = searchTerm.toLowerCase();

        return dummyData.filter(d => {
            // match top-level row fields (order id, platform, linkage) or inside listings
            const matchesTop =
                (d.name && d.name.toLowerCase().includes(term)) ||
                (d.platform && d.platform.toLowerCase().includes(term)) ||
                (d.platformStatus && d.platformStatus.toLowerCase().includes(term)) ||
                (d.orderTotal && d.orderTotal.toLowerCase().includes(term)) ||
                (d.linkage && d.linkage.toLowerCase().includes(term));

            const matchesListings = Array.isArray(d.listings) && d.listings.some(l =>
                (l.listingName || '').toLowerCase().includes(term) ||
                (l.variation || '').toLowerCase().includes(term) ||
                (l.mappedStock || '').toLowerCase().includes(term) ||
                (l.stockInstance || '').toLowerCase().includes(term)
            );

            const matchesStatus =
                statusFilter === '' || (d.platformStatus && d.platformStatus.toLowerCase() === statusFilter.toLowerCase());

            return (matchesTop || matchesListings) && matchesStatus;
        });
    }, [searchTerm, statusFilter]);

    // pagination using your names
    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const pageData = filtered.slice(
        (currentPage - 1) * PAGE_SIZE,
        currentPage * PAGE_SIZE
    );

    // keep original onRowClick behavior (opens drawer)
    const onRowClick = (row) => {
        setSelectedRow(row);
        setDrawerTab('entity-info');
        setDrawerOpen(true);
    };

    // Close single‐row Drawer when clicking outside
    useEffect(() => {
        function handleClickOutsideDrawer(event) {
            if (!drawerOpen) return;
            const target = event.target;
            if (drawerRef.current && drawerRef.current.contains(target)) return;
            if (filterDrawerRef.current && filterDrawerRef.current.contains(target)) return;
            if (toolbarRef?.current && toolbarRef.current.contains(target)) return;
            if (dropdownRef.current && dropdownRef.current.contains(target)) return;
            if (imeiDropdownRef && imeiDropdownRef.current && imeiDropdownRef.current.contains(target)) return;
            setDrawerOpen(false);
            setSelectedRow(null);
            setSelectedIds(ids => selectedRow ? ids.filter(id => id !== selectedRow.id) : ids);
        }

        document.addEventListener('mousedown', handleClickOutsideDrawer);
        return () => document.removeEventListener('mousedown', handleClickOutsideDrawer);
    }, [drawerOpen, selectedRow]);

    // dropdown positioning and outside click logic preserved
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !buttonRefs.current[dropdownOpenId]?.contains(event.target)
            ) {
                setDropdownOpenId(null);
            }
        }

        if (dropdownOpenId !== null) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpenId]);

    const toggleDropdown = (id) => {
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
        } else {
            const btn = buttonRefs.current[id];
            if (btn) {
                const rect = btn.getBoundingClientRect();
                const dropdownWidth = 150;
                const dropdownHeight = 100;

                let left = rect.left + window.scrollX - dropdownWidth + rect.width;
                if (left < window.scrollX + 8) {
                    left = window.scrollX + 8;
                }

                let top = rect.bottom + window.scrollY;
                if (top + dropdownHeight > window.scrollY + window.innerHeight) {
                    top = rect.top + window.scrollY - dropdownHeight;
                }

                setDropdownPosition({ top, left });
            }
            setDropdownOpenId(id);
        }
    };

    // Drawer Dropdown latest code below
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const toolbarRef = useRef(null);
    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
                setToolbarDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // minimal accordion toggle (preserves all other behavior)
    const toggleExpand = (id, e) => {
        // prevent row click from opening drawer when clicking caret
        if (e) e.stopPropagation();
        setExpandedIds(prev => {
            if (prev.includes(id)) return prev.filter(x => x !== id);
            return [...prev, id];
        });
    };

    const copyToClipboard = (text) => {
        if (!text) return;
        try { navigator.clipboard.writeText(text); } catch (err) { /* ignore */ }
    };

    // ---------- Drawer (order-items) pagination state & helpers ----------
    const DRAWER_PAGE_SIZE = 5;
    const [drawerCurrentPage, setDrawerCurrentPage] = useState(1);

    // reset drawer page when selectedRow changes
    useEffect(() => {
        setDrawerCurrentPage(1);
    }, [selectedRow]);

    const getDrawerListings = () => {
        if (!selectedRow || !Array.isArray(selectedRow.listings)) return [];
        return selectedRow.listings;
    };

    const drawerListings = getDrawerListings();
    const drawerTotal = drawerListings.length;
    const drawerTotalPages = Math.max(1, Math.ceil(drawerTotal / DRAWER_PAGE_SIZE));
    const drawerPageData = drawerListings.slice(
        (drawerCurrentPage - 1) * DRAWER_PAGE_SIZE,
        drawerCurrentPage * DRAWER_PAGE_SIZE
    );


    return (
        <div className="company-body new-look stock-wrap">
            {/* Breadcrumbs */}
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => (
                    <span key={index} className="breadcrumb-item">
                        {crumb}
                        {index !== breadcrumbs.length - 1}
                    </span>
                ))}
            </div>

            <div className="employee-tabs-container">
                {/* ─── Tab Buttons ─── */}
                <div className="tabs">
                    <button
                        // Apply the "active" class only when this tab is selected
                        className={`tab ${activeTab === 'platform-order' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('platform-order')}
                    >
                        Platform Order
                    </button>
                </div>

                {/* ─── Tab Contents ─── */}
                {activeTab === 'platform-order' && (
                    <div className="tab-content" id="platform-order-content">
                        {/* Platform Order Card */}
                        <div className="info-section">
                            <div className="info-card">
                                <div className="info-header">
                                    <h4 className="info-title">Platform Order</h4>
                                </div>

                                <div className="entities-tab">
                                    {/* Toolbar: Search + Filter on left; Edit/Plus on right */}
                                    <div className="toolbar" ref={toolbarRef}>
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={searchTerm}
                                                    onChange={e => {
                                                        setSearchTerm(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                            <button className="icon-btn">
                                                <Funnel size={18} /> Filter
                                            </button>

                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div className="table-wrapper">
                                        <table className="entities-table" ref={tableRef}>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <span>
                                                            Order ID <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Order Date <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Platform <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Platform Status <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Items <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Order Total <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Final Total <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Linkage <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th style={{ textAlign: 'center' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pageData.map((row, idx) => {
                                                    const isRowSelected = (selectedIds.includes(row.id) || dropdownOpenId === row.id) && !suppressHighlight;
                                                    const expanded = expandedIds.includes(row.id);

                                                    return (
                                                        <React.Fragment key={row.id + '-' + idx}>
                                                            <tr
                                                                className={[
                                                                    idx % 2 ? 'striped' : '',
                                                                    isRowSelected ? 'row-selected' : '',
                                                                    expanded ? 'expanded-bg' : ''
                                                                ].join(' ')}
                                                                onClick={() => onRowClick(row)}
                                                            >
                                                                <td>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                        <button
                                                                            className="caret-btn"
                                                                            onClick={(e) => toggleExpand(row.id, e)}
                                                                            aria-label={expanded ? 'Collapse' : 'Expand'}
                                                                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, marginRight: 6 }}
                                                                        >
                                                                            {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                                                        </button>
                                                                        <div>{row.name}</div>
                                                                    </div>
                                                                </td>

                                                                <td>{row.orderDate}</td>
                                                                <td>{row.platform}</td>
                                                                <td>
                                                                    <span className={`status ${row.platformStatus.toLowerCase().replace(/\s/g, '-')}`}>{row.platformStatus}</span>
                                                                </td>
                                                                <td>{row.itemsCount}</td>
                                                                <td>{row.orderTotal}</td>
                                                                <td>{row.finalTotal}</td>
                                                                <td>
                                                                    <span className={`status ${row.linkage.toLowerCase().replace(/\s/g, '-').replace(/\(.*\)/, '').trim()}`}>
                                                                        {row.linkage}
                                                                    </span>
                                                                </td>

                                                                <td style={{ textAlign: "center", position: "relative" }}>
                                                                    <button
                                                                        ref={el => (buttonRefs.current[row.id] = el)}
                                                                        className="icon-btn"
                                                                        onClick={e => { e.stopPropagation(); toggleDropdown(row.id); }}
                                                                    >
                                                                        <MoreHorizontal size={20} />
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                            {/* Accordion content - inserted immediately after the clicked row */}
                                                            {expanded && (
                                                                <tr className="accordion-row">
                                                                    <td colSpan={11} style={{ padding: 0 }}>
                                                                        <div className="accordion-inner" style={{ borderLeft: '3px solid #FFEB00', background: '#FFFEF0' }}>
                                                                            <table className="accordion-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                                <colgroup>
                                                                                    <col style={{ width: '28%' }} />
                                                                                    <col style={{ width: '2%' }} />
                                                                                    <col style={{ width: '13%' }} />
                                                                                    <col style={{ width: '18%' }} />
                                                                                    <col style={{ width: '15%' }} />
                                                                                    <col style={{ width: '2%' }} />
                                                                                    <col style={{ width: '21%' }} />
                                                                                </colgroup>
                                                                                <thead>
                                                                                    <tr style={{ background: '#FFEB00' }}>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Listing Name</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Qty</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Unit Price</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Mapped Stock</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Stock Instance</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Qty</th>
                                                                                        <th style={{ background: '#FFEB00', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Instance Status</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {Array.isArray(row.listings) && row.listings.length > 0 ? (
                                                                                        row.listings.map(listing => (
                                                                                            <tr
                                                                                                key={listing.id}
                                                                                                className={`listing-row ${listing.rowBg === 'stockout' ? 'stockout' : ''}`}
                                                                                                style={{
                                                                                                    background: listing.rowBg === 'stockout' ? '#FEF1F1' : '#FFFEF0'
                                                                                                }}
                                                                                            >
                                                                                                <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                                                    <div style={{ display: 'flex', gap: 12 }}>
                                                                                                        <img
                                                                                                            src={listing.avatar || ''}
                                                                                                            alt=""
                                                                                                            className="avatar"
                                                                                                            style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6, flex: 'none' }}
                                                                                                        />
                                                                                                        <div style={{ whiteSpace: 'pre-line' }}>
                                                                                                            <div>{listing.listingName}</div>
                                                                                                            <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{`Variation: ${listing.variation}`}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </td>

                                                                                                <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>{listing.qty}</td>

                                                                                                <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>{listing.unitPrice}</td>

                                                                                                <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0, whiteSpace: "normal" }}>
                                                                                                    {listing.rowBg === 'stockout' ? (
                                                                                                        <div style={{ fontWeight: 600, color: '#58151C' }}>{listing.mappedStock}</div>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <div>{listing.mappedStock}</div>
                                                                                                            {listing.mappedStockSku && (
                                                                                                                <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.mappedStockSku}</div>
                                                                                                            )}
                                                                                                            {(Array.isArray(listing.mappedStockBadges) && listing.mappedStockBadges.length > 0) ||
                                                                                                                (Array.isArray(listing.mappedStockBadgesRight) && listing.mappedStockBadgesRight.length > 0) ? (
                                                                                                                <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                                                                    {/* Left badges */}
                                                                                                                    {listing.mappedStockBadges?.map((b, i) => (
                                                                                                                        <span
                                                                                                                            key={`left-${i}`}
                                                                                                                            style={{
                                                                                                                                fontSize: 8,
                                                                                                                                fontWeight: 600,
                                                                                                                                lineHeight: "normal",
                                                                                                                                padding: '2px 8px',
                                                                                                                                background: '#D1E7DD',
                                                                                                                                borderRadius: 99,
                                                                                                                                color: '#198754',
                                                                                                                                border: '1px solid #198754'
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {b}
                                                                                                                        </span>
                                                                                                                    ))}

                                                                                                                    {/* Right badges */}
                                                                                                                    {listing.mappedStockBadgesRight?.map((b, i) => (
                                                                                                                        <span
                                                                                                                            key={`right-${i}`}
                                                                                                                            style={{
                                                                                                                                fontSize: 10,
                                                                                                                                color: "#6C757D",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {b}
                                                                                                                        </span>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            ) : null}
                                                                                                        </>
                                                                                                    )}
                                                                                                </td>

                                                                                                <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                                                    {listing.stockInstance ? (
                                                                                                        <div>
                                                                                                            <div style={{ color: '#0D6EFD', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                                                                <span onClick={() => copyToClipboard(listing.stockInstance)} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                                                                                                    {listing.stockInstance}
                                                                                                                </span>
                                                                                                                <Copy size={13} onClick={() => copyToClipboard(listing.stockInstance)} style={{ cursor: 'pointer', color: '#0D6EFD' }} />
                                                                                                            </div>
                                                                                                            <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.stockInstanceLocation}</div>
                                                                                                            <div style={{ fontSize: 10, color: '#6C757D', marginTop: 2 }}>{listing.stockInstanceDate}</div>
                                                                                                            <div style={{ marginTop: 12 }}>
                                                                                                                <button className="relink-btn" style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff', cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600 }}>
                                                                                                                    <LinkIcon size={18} style={{ marginRight: 6 }} /> Re-Link
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <div>
                                                                                                            {listing.rowBg === 'stockout' ? (
                                                                                                                <button className="link-btn disabled" disabled style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #ADB5BD', background: '#E9ECEF', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#ADB5BD', fontSize: 12, fontWeight: 600 }}>
                                                                                                                    <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                                                                </button>
                                                                                                            ) : (
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="link-btn as"
                                                                                                                    style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff', cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600 }}
                                                                                                                    onClick={(e) => { e.stopPropagation(); history.push('/platform-order/link-stock-instance'); }}
                                                                                                                >
                                                                                                                    <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                                                                </button>

                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </td>

                                                                                                <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>{listing.instanceQty}</td>

                                                                                                <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                                                    {listing.instanceStatus ? (
                                                                                                        <div className={`status ${listing.instanceStatus.toLowerCase().replace(/\s/g, '-')}`}>
                                                                                                            {listing.instanceStatus}
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <div style={{ height: 22 }} />
                                                                                                    )}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    ) : (
                                                                                        <tr>
                                                                                            <td colSpan={7} style={{ padding: 12, color: '#212529', border: 0 }}>No listings for this order</td>
                                                                                        </tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                        </React.Fragment>
                                                    );
                                                })}

                                                {/* fill empty rows */}
                                                {pageData.length < PAGE_SIZE && (
                                                    [...Array(PAGE_SIZE - pageData.length)].map((_, idx) => (
                                                        <tr key={`empty-${idx}`} className="empty-row" onClick={() => { }}>
                                                            <td colSpan={11}>&nbsp;</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>

                                        {/* Per-row dropdown menu (kept same) */}
                                        {dropdownOpenId !== null && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                alert("View Details clicked");
                                                                setDropdownOpenId(null);
                                                            }}
                                                        >
                                                            View Details
                                                        </button>
                                                    </div>

                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={(e) => { e.stopPropagation(); history.push('/platform-order/link-stock-instance'); }}
                                                        >
                                                            Link Instance
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Pagination (kept) */}
                                    <div className="pagination">
                                        <div className="pagination-info">
                                            {`Showing ${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, filtered.length)} of ${filtered.length} items`}
                                        </div>
                                        <div className="pagination-controls">
                                            <button
                                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                                disabled={currentPage === 1}
                                            >
                                                <ChevronLeft size={20} />
                                            </button>
                                            {[...Array(totalPages)].map((_, i) => (
                                                <button
                                                    key={i}
                                                    className={currentPage === i + 1 ? 'active' : ''}
                                                    onClick={() => setCurrentPage(i + 1)}
                                                >
                                                    {i + 1}
                                                </button>
                                            ))}
                                            <button
                                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                                disabled={currentPage === totalPages}
                                            >
                                                <ChevronRight size={20} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="drawer-container" ref={drawerContainerRef}>
                            {/* Single‐row Drawer (unchanged) */}
                            {drawerOpen && selectedRow && (() => {
                                const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                                const total = Number(selectedRow.available || 0) + pendingCount;
                                return (
                                    <>
                                        <div className="drawer-overlay main-drawer-overlay" />
                                        <div className="entity-drawer" ref={drawerRef}>
                                            <div className="drawer-header">
                                                <h3>Order Info</h3>
                                                <button
                                                    className="close-btn"
                                                    onClick={() => {
                                                        setDrawerOpen(false);
                                                        setSelectedIds(ids => ids.filter(id => id !== selectedRow?.id));
                                                        setSelectedRow(null);
                                                    }}
                                                >
                                                    <X size={24} />
                                                </button>
                                            </div>
                                            <div className="main-drawer-inner" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                <div className="drawer-title d-flex align-items-center justify-content-between">
                                                    <div className='d-flex align-items-center'>
                                                        <h2 className='pb-0'>{selectedRow?.name}</h2>
                                                    </div>
                                                </div>

                                                <div className="drawer-tabs">
                                                    <button
                                                        className={drawerTab === 'entity-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('entity-info')}
                                                    >
                                                        Product Info
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'order-items' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('order-items')}
                                                    >
                                                        Order Items
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'additional-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('additional-info')}
                                                    >
                                                        Additional Info
                                                    </button>
                                                </div>

                                                <div className="drawer-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                    {drawerTab === 'entity-info' && (
                                                        <div className="tab-panel entity-info-panel">
                                                            <div className="field-block">
                                                                <div className="field-label">Order ID</div>
                                                                <div className="field-value">
                                                                    {selectedRow.name}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Platform</div>
                                                                <div className="field-value">
                                                                    {selectedRow.platform}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Platform Status</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${selectedRow.platformStatus.toLowerCase().replace(/\s/g, '-')}`}>
                                                                        {selectedRow.platformStatus}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Order Items</div>
                                                                <div className="field-value">
                                                                    {selectedRow.itemsCount}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Order Total</div>
                                                                <div className="field-value">
                                                                    {selectedRow.orderTotal}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Linkage</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${selectedRow.linkage.toLowerCase().replace(/\s/g, '-').replace(/\(.*\)/, '').trim()}`}>
                                                                        {selectedRow.linkage}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'order-items' && (
                                                        <div className="tab-panel order-items-panel" style={{ height: '100%' }}>
                                                            {/* Drawer Order Items table */}
                                                            <div className='entities-tab' style={{ padding: 0, paddingTop: '20px' }}>
                                                                <div className='table-wrapper'>
                                                                    <table className="entities-table" style={{ minWidth: "unset" }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Listing Name</th>
                                                                                <th>Qty</th>
                                                                                <th>Unit Price</th>
                                                                                <th>Mapped Stock</th>
                                                                                <th>Stock Instance</th>
                                                                                <th>Qty</th>
                                                                                <th>Instance Status</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {drawerPageData.length > 0 ? (
                                                                                drawerPageData.map(listing => (
                                                                                    <tr
                                                                                        key={listing.id}
                                                                                        className={`listing-row ${listing.rowBg === 'stockout' ? 'stockout' : ''}`}
                                                                                        style={{ background: listing.rowBg === 'stockout' ? '#FEF1F1' : 'transparent' }}
                                                                                    >
                                                                                        <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                                                                                <img
                                                                                                    src={listing.avatar || ''}
                                                                                                    alt=""
                                                                                                    className="avatar"
                                                                                                    style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6, flex: 'none' }}
                                                                                                />
                                                                                                <div style={{ whiteSpace: 'pre-line' }}>
                                                                                                    <div>{listing.listingName}</div>
                                                                                                    <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{`Variation: ${listing.variation}`}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                                            {listing.qty}
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                                            {listing.unitPrice}
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0, whiteSpace: "normal" }}>
                                                                                            {listing.rowBg === 'stockout' ? (
                                                                                                <div style={{ fontWeight: 600, color: '#58151C' }}>{listing.mappedStock}</div>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div>{listing.mappedStock}</div>
                                                                                                    {listing.mappedStockSku && (
                                                                                                        <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.mappedStockSku}</div>
                                                                                                    )}
                                                                                                    {(Array.isArray(listing.mappedStockBadges) && listing.mappedStockBadges.length > 0) ||
                                                                                                        (Array.isArray(listing.mappedStockBadgesRight) && listing.mappedStockBadgesRight.length > 0) ? (
                                                                                                        <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                                                            {listing.mappedStockBadges?.map((b, i) => (
                                                                                                                <span
                                                                                                                    key={`left-${i}`}
                                                                                                                    style={{
                                                                                                                        fontSize: 8,
                                                                                                                        fontWeight: 600,
                                                                                                                        lineHeight: "normal",
                                                                                                                        padding: '2px 8px',
                                                                                                                        background: '#D1E7DD',
                                                                                                                        borderRadius: 99,
                                                                                                                        color: '#198754',
                                                                                                                        border: '1px solid #198754'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {b}
                                                                                                                </span>
                                                                                                            ))}

                                                                                                            {listing.mappedStockBadgesRight?.map((b, i) => (
                                                                                                                <span key={`right-${i}`} style={{ fontSize: 10, color: "#6C757D" }}>
                                                                                                                    {b}
                                                                                                                </span>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    ) : null}
                                                                                                </>
                                                                                            )}
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                                            {listing.stockInstance ? (
                                                                                                <div>
                                                                                                    <div style={{ color: '#0D6EFD', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                                                        <span
                                                                                                            onClick={() => copyToClipboard(listing.stockInstance)}
                                                                                                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                                                        >
                                                                                                            {listing.stockInstance}
                                                                                                        </span>
                                                                                                        <Copy size={13} onClick={() => copyToClipboard(listing.stockInstance)} style={{ cursor: 'pointer', color: '#0D6EFD' }} />
                                                                                                    </div>
                                                                                                    {listing.stockInstanceLocation && <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.stockInstanceLocation}</div>}
                                                                                                    {listing.stockInstanceDate && <div style={{ fontSize: 10, color: '#6C757D', marginTop: 2 }}>{listing.stockInstanceDate}</div>}
                                                                                                    <div style={{ marginTop: 12 }}>
                                                                                                        <button className="relink-btn" style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff', cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600 }}>
                                                                                                            <LinkIcon size={18} style={{ marginRight: 6 }} /> Re-Link
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div>
                                                                                                    {listing.rowBg === 'stockout' ? (
                                                                                                        <button className="link-btn disabled" disabled style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #ADB5BD', background: '#E9ECEF', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#ADB5BD', fontSize: 12, fontWeight: 600 }}>
                                                                                                            <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="link-btn as"
                                                                                                            style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff', cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600 }}
                                                                                                            onClick={(e) => { e.stopPropagation(); history.push('/platform-order/link-stock-instance'); }}
                                                                                                        >
                                                                                                            <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                                                        </button>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                                            {listing.instanceQty}
                                                                                        </td>

                                                                                        <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                                            {listing.instanceStatus ? (
                                                                                                <div className={`status ${listing.instanceStatus.toLowerCase().replace(/\s/g, '-')}`}>
                                                                                                    {listing.instanceStatus}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div style={{ height: 22 }} />
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan={7} style={{ padding: 12, color: '#212529', border: 0 }}>No listings for this order</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                {/* Drawer pagination & info */}
                                                                <div className="pagination" style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <div className="pagination-info">
                                                                        {`Showing ${drawerTotal === 0 ? 0 : (drawerCurrentPage - 1) * DRAWER_PAGE_SIZE + 1} - ${Math.min(drawerCurrentPage * DRAWER_PAGE_SIZE, drawerTotal)} of ${drawerTotal} items`}
                                                                    </div>

                                                                    <div className="pagination-controls" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                                                        <button
                                                                            onClick={() => setDrawerCurrentPage(p => Math.max(1, p - 1))}
                                                                            disabled={drawerCurrentPage === 1}
                                                                        >
                                                                            <ChevronLeft size={18} />
                                                                        </button>

                                                                        {[...Array(drawerTotalPages)].map((_, i) => (
                                                                            <button
                                                                                key={i}
                                                                                className={drawerCurrentPage === i + 1 ? 'active' : ''}
                                                                                onClick={() => setDrawerCurrentPage(i + 1)}
                                                                            >
                                                                                {i + 1}
                                                                            </button>
                                                                        ))}

                                                                        <button
                                                                            onClick={() => setDrawerCurrentPage(p => Math.min(drawerTotalPages, p + 1))}
                                                                            disabled={drawerCurrentPage === drawerTotalPages}
                                                                        >
                                                                            <ChevronRight size={18} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='main-company-body-inner' style={{ marginTop: 'auto' }}>
                                                                <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'>
                                                                    <button
                                                                        className="dark-border"
                                                                        type='button'
                                                                        onClick={(e) => { e.stopPropagation(); history.push('/platform-order/link-stock-instance'); }}
                                                                    >
                                                                        Link Instance
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'additional-info' && (
                                                        <div className="tab-panel additional-info-panel">
                                                            <p className="note-type-added">Note</p>
                                                            <label className="no-description-cls">No Description</label>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                );

                            })()}
                        </div>

                    </div>
                )}
            </div>


        </div>
    );
};
